import scrollIt from './scrollit';

document.addEventListener('click', event => {
  if (
    event.target.matches('a[href^="#"]:not([href="#"]):not(.js-tab-control):not([href="#cc-link"])')
  ) {
    event.preventDefault();
    const target = document.getElementById(
      event.target
        .getAttribute('href')
        .split('#')
        .slice(-1),
    );

    scrollIt(target.offsetTop - 90, 500, 'easeOutCubic');
  }
});



// WEBPACK FOOTER //
// ./src/js/scroll-to-hashtag.js